import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoaderComponent } from './loader.component';
import { RetryModule } from '../retry/retry.module';
import { RetryBlockScopedModule } from '../retry-block-scoped/retry-block-scoped.module';
import { DotLoaderComponent } from './dot-loader/dot-loader.component';

@NgModule({
  imports: [
    CommonModule,
    RetryModule,
    RetryBlockScopedModule
  ],
  declarations: [LoaderComponent, DotLoaderComponent],
  exports: [LoaderComponent,
    DotLoaderComponent]
})
export class LoaderModule {}
